export const RewardMethodToNotificationName = {
    raffle: 'raffle-reward-distributed',
    top: 'top-reward-distributed',
    vote: 'vote-reward-distributed',
};
